const SESSION_KEY = 'session';
const ACCESS_TOKEN_KEY = 'accessToken';
const REFRESH_TOKEN_KEY = 'refreshToken';

const safeParseJson = (value) => {
  if (!value) return null;

  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

const readLegacyToken = (key) => {
  try {
    const value = localStorage.getItem(key);
    return value && value !== 'null' && value !== 'undefined' ? value : null;
  } catch {
    return null;
  }
};

export const readPersistedSession = () => {
  try {
    const session = safeParseJson(localStorage.getItem(SESSION_KEY));
    if (session && typeof session === 'object') {
      return session;
    }
  } catch {
    // Fall through to legacy keys.
  }

  const accessToken = readLegacyToken(ACCESS_TOKEN_KEY);
  const refreshToken = readLegacyToken(REFRESH_TOKEN_KEY);

  if (!accessToken && !refreshToken) {
    return null;
  }

  return {
    accessToken,
    refreshToken,
    user: null
  };
};

export const getPersistedAuthState = () => {
  const session = readPersistedSession();

  return {
    user: session?.user || null,
    accessToken: session?.accessToken || null,
    refreshToken: session?.refreshToken || null,
    isAuthenticated: Boolean(session?.accessToken)
  };
};

export const writePersistedSession = (sessionData) => {
  try {
    if (!sessionData || typeof sessionData !== 'object') {
      return;
    }

    const normalizedSession = {
      user: sessionData.user ?? null,
      accessToken: sessionData.accessToken ?? null,
      refreshToken: sessionData.refreshToken ?? null
    };

    localStorage.setItem(SESSION_KEY, JSON.stringify(normalizedSession));

    if (normalizedSession.accessToken) {
      localStorage.setItem(ACCESS_TOKEN_KEY, normalizedSession.accessToken);
    } else {
      localStorage.removeItem(ACCESS_TOKEN_KEY);
    }

    if (normalizedSession.refreshToken) {
      localStorage.setItem(REFRESH_TOKEN_KEY, normalizedSession.refreshToken);
    } else {
      localStorage.removeItem(REFRESH_TOKEN_KEY);
    }
  } catch {
    // Ignore storage failures so auth state can still exist in memory.
  }
};

export const clearPersistedSession = () => {
  try {
    localStorage.removeItem(SESSION_KEY);
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  } catch {
    // Ignore storage failures during logout.
  }
};

export const getPersistedAccessToken = () => getPersistedAuthState().accessToken;

